import { initialStepSchema } from '../../../schemas/initialStepSchema';
import { Program } from '../../../types/program';
import { formatInitialStepValues } from '../../steps/initialStep/formatInitialStepValues';

export const verifyCompletedInitialStep = async (program?: Program | null) => {
  if (!program) return false;

  const formattedValues = formatInitialStepValues(program);
  try {
    await initialStepSchema.validate(formattedValues, { abortEarly: false });
    return true;
  } catch (error) {
    return false;
  }
};
